export default __webpack_public_path__ + "/dist/images/interact-icon.264eaa8cfea9128df21e1ddd25a951ef.svg";